import { render, staticRenderFns } from "./permissionRow.vue?vue&type=template&id=9955a75a&scoped=true"
import script from "./permissionRow.vue?vue&type=script&lang=js"
export * from "./permissionRow.vue?vue&type=script&lang=js"
import style0 from "./permissionRow.vue?vue&type=style&index=0&id=9955a75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9955a75a",
  null
  
)

export default component.exports